<div class="container">
  @if (currentStep) {
    <progress-bar [currentStep]="currentStep" [totalSteps]="totalSteps"></progress-bar>
  }
</div>
<div [ngClass]="[headerImage ? 'has-image ' + headerImage : '']" class="heading">
  <div class="heading-trans">
    <div class="container">
      <div class="heading-copy pt-4">
        <h2 class="mb-0">{{title}}</h2>
        @if (subTitle) {
          <h5 class="my-4">{{subTitle}}</h5>
        }
        @if (summary) {
          <div [innerHTML]="summary"> </div>
        }
      </div>
    </div>
  </div>
</div>
